export const BASE_ROW_MARGIN = 7.5;
